const data = [
    {
        id : 1,
        heading : "Logistics",
        body : "Our carriers have been hand selected and thoroughly\
         vetted to make sure they are safe and reliable. We take all \
         responsibility for the load from pickup to delivery. \
         You will never have to chase a third party to get answers.",
         image: "https://ik.imagekit.io/qwj4cqxdwl/2023/03/freight-2.png?updatedAt=1712780219019",
    },

    {
        id : 2,
        heading : "Supply Chain",
        body : "Our local team acts as your own sourcing & procurement \
        department to ensure total transparency at all times. Our systematic \
        ordering procedures ensure we deliver consistent quality.",
        image: "https://ik.imagekit.io/qwj4cqxdwl/2023/03/supply-chain-management-2.png?updatedAt=1712780242572",
    },
      {
        id : 3,
        heading : "Brokerage",
        body : "Through our brokerage services, we connect you with the right \
        carriers, routes, and solutions tailored to your specific needs. \
        By leveraging our extensive network and industry expertise, we negotiate \
         the best rates, reduce risk, and guarantee timely deliveries-giving you \
         flexibility and control without compromising on reliability.",
        image: "https://ik.imagekit.io/qwj4cqxdwl/2023/03/brokerage(3).png?updatedAt=1762508835274",
    },

] 

export default data;